<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18f4g0M/tc-custom/9780062899897.jpg?1731883381574" alt="This image is the cover for the book Sacrament"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sacrament
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The haunting, vivid story of a nun whose past returns to her in unexpected ways, all while investigating a mysterious death and a series of harrowing abuse claims</b></p><p>A young nun is sent by the Vatican to investigate allegations of misconduct at a Catholic school in Iceland. During her time there, on a gray winter’s day, a young student at the school watches the school’s headmaster, Father August Franz, fall to his death from the church tower.</p><p>Two decades later, the child—now a grown man, haunted by the past—calls the nun back to the scene of the crime. Seeking peace and calm in her twilight years at a convent in France, she has no choice to make a trip to Iceland again, a trip that brings her former visit, as well as her years as a young woman in Paris, powerfully and sometimes painfully to life. In Paris, she met an Icelandic girl who she has not seen since, but whose acquaintance changed her life, a relationship she relives all while reckoning with the mystery of August Franz’s death and the abuses of power that may have brought it on.</p><p>In <i>The Sacrament</i>, critically acclaimed novelist Olaf Olafsson looks deeply at the complexity of our past lives and selves; the faulty nature of memory; and the indelible mark left by the joys and traumas of youth. Affecting and beautifully observed, <i>The Sacrament </i>is both propulsively told and poignantly written—tinged with the tragedy of life’s regrets but also moved by the possibilities of redemption, a new work from a novelist who consistently surprises and challenges.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Olaf Olafsson
      </h2>
      
      <p class="authorDescription body article"><P><B>Olaf Olafsson </B>was born in Reykjavik, Iceland, in 1962. He studied physics as a Wien scholar at Brandeis University. He is the author of six previous novels, <I>The Journey Home</I>,<I> Absolution</I>,<I> Walking into the Night</I>,<I> Restoration</I>, <I>One Station Away</I>, and <I>The Sacrament</I>, and a story collection, <I>Valentines</I>. He spends his time in New York City, Sag Harbor, and Reykjavik.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ee7905e